import { render, staticRenderFns } from "./territoryFilter.vue?vue&type=template&id=16c3cd4b"
import script from "./territoryFilter.vue?vue&type=script&lang=js"
export * from "./territoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports